var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"color":"red","large":""}},[_vm._v("mdi-fire")])
}
var staticRenderFns = []

export { render, staticRenderFns }